import {
  ChartDataSets,
  ChartOptions,
  ChartScales,
  ChartXAxe,
  ChartYAxe,
  TickOptions,
  TimeScale,
} from "chart.js";
import React from "react";
import { Bar } from "react-chartjs-2";
import { baseOption, colors } from "../../utils";

interface BarChartOptions {
  data: any[];
}

const options: ChartOptions = {
  scales: {
    xAxes: [
      {
        stacked: true,
        position: "bottom",
        type: "time",
        distribution: "linear",
        time: {
          unitStepSize: 3,
          minUnit: "day",
          unit: "day",
        } as TimeScale,
      },
    ] as ChartXAxe[],
    yAxes: [
      {
        stacked: true,
        position: "left",
        ticks: {
          beginAtZero: true,
        } as TickOptions,
        scaleLabel: {
          display: true,
          labelString: "",
        },
      },
    ] as ChartYAxe[],
  } as ChartScales,
  legend: {
    display: true,
    position: "right",
    labels: {
      padding: 20,
    },
  },
  maintainAspectRatio: false,
};

export const BarChart: React.FC<BarChartOptions> = (props) => {
  const { data } = props;

  return (
    <Bar
      data={{
        datasets: data.map((row, index) => {
          return {
            ...row,
            ...baseOption(colors[index]),
          } as ChartDataSets;
        }),
      }}
      options={options}
    />
  );
};
